module.exports = __webpack_public_path__ + "static/media/07.12de7eb6.jpg";